var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppSubstance3DDesigner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#1E3101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3257 14.4297C24.5039 14.4297 30.4614 18.4629 30.4614 26.4924C30.4614 34.1521 24.6523 39.2214 17.1406 39.2214H7.4458V14.4297H17.3257ZM14.3281 33.3381H17.6587C20.7666 33.3381 23.0239 30.8218 23.0239 26.7515C23.0239 22.3113 20.915 20.3132 17.4365 20.3132H14.3281V33.3381Z",
    fill: "#99E83F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5684 38.0002L32.6055 32.2649C34.5664 33.5601 37.3047 34.374 39.1919 34.374C40.4873 34.374 41.0791 34.0041 41.0791 33.3381C41.0791 32.5979 40.2652 32.302 38.711 31.821C35.7139 30.9329 32.4204 29.7117 32.4204 25.7895C32.4204 21.7932 35.7139 19.573 40.4873 19.573C42.7442 19.573 44.5942 19.906 46.2227 20.6091L46.1856 26.0854C44.8906 25.3083 42.3369 24.6055 40.6719 24.6055C39.4512 24.6055 38.9697 24.9753 38.9697 25.5305C38.9697 26.1965 39.562 26.3816 41.3379 26.9365C44.7793 27.9727 47.6655 29.0828 47.6655 33.116C47.6655 36.9644 44.5205 39.5544 39.5991 39.5544C37.0088 39.5544 34.5664 39.1103 32.5684 38.0002Z",
    fill: "#99E83F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppSubstance3DDesigner);
export default __webpack_public_path__ + "static/media/B_app_Substance3DDesigner.88a17f138126d942f8f7dc829189eed6.svg";
export { ForwardRef as ReactComponent };